import PropTypes from 'prop-types'
import React from 'react'
import { useHistory } from 'react-router-dom'

import { Container, TitleWrapper, TitleContainer, CategoryTitle, HeaderBackButton } from './styles'

const RewardsCategoryDetailsHeader = ({ categoryName }) => {
  const history = useHistory()

  return (
    <Container>
      <TitleWrapper>
        <HeaderBackButton
          className="killi-icon-arrow-back-ios"
          onClick={() => {
            history.replace({ ...history.location, state: { selectedCategory: null } })
          }}
        />
        <TitleContainer>
          <CategoryTitle>{categoryName}</CategoryTitle>
        </TitleContainer>
      </TitleWrapper>
    </Container>
  )
}

RewardsCategoryDetailsHeader.propTypes = {
  categoryName: PropTypes.string.isRequired,
}

export default RewardsCategoryDetailsHeader
